import { PermissionCode } from "@CommonUtils/RolesPermissions";
import { IconType } from "src/elements/Icon";
import { pages } from "src/utils";

export type SidebarTitleKey =
  | "performance"
  | "assortment"
  | "spacePlanning"
  | "imagine"
  | "categories"
  | "stores"
  | "products"
  | "fixtures"
  | "projects"
  | "merchflows"
  | "storeSummary"
  | "users"
  | "audit";

export interface SidebarMenuItem {
  titleKey: SidebarTitleKey;
  path: string;
  icon: IconType;
  hidden?: boolean;
  permission?: PermissionCode;
  highlightGreen?: boolean;
}

export const sidebarMenu: SidebarMenuItem[] = [
  {
    titleKey: "performance",
    path: pages.microspaceAnalysis,
    icon: "barChart",
    highlightGreen: true,
  },
  {
    titleKey: "assortment",
    path: pages.assortmentSimulation,
    icon: "box",
    highlightGreen: true,
  },
  {
    titleKey: "spacePlanning",
    path: pages.spacePlanning,
    icon: "grid3x3",
    highlightGreen: true,
  },
  {
    titleKey: "imagine",
    path: pages.imagine,
    icon: "ai",
    permission: PermissionCode.IMAGINE_READ,
  },
  {
    titleKey: "categories",
    path: pages.categories,
    icon: "categories",
    permission: PermissionCode.CATEGORIES_UPDATE,
  },
  {
    titleKey: "stores",
    path: pages.stores,
    icon: "stores",
    permission: PermissionCode.STORES_UPDATE,
  },
  {
    titleKey: "products",
    path: pages.products,
    icon: "basket",
    permission: PermissionCode.PRODUCTS_READ,
  },
  {
    titleKey: "fixtures",
    path: pages.fixtures,
    icon: "fixtures",
    permission: PermissionCode.FIXTURES_READ,
  },
  {
    titleKey: "projects",
    path: pages.projects,
    icon: "projects",
    permission: PermissionCode.PROJECTS_READ,
  },
  {
    titleKey: "merchflows",
    path: pages.merchflows,
    icon: "merchflows",
  },
  {
    titleKey: "storeSummary",
    path: pages.storeSummary,
    icon: "stores",
    permission: PermissionCode.STORE_SUMMARY_READ,
  },
  {
    titleKey: "users",
    path: pages.users,
    icon: "users",
    permission: PermissionCode.USERS_UPDATE,
  },
  {
    titleKey: "audit",
    path: pages.auditLogs,
    icon: "summary",
    permission: PermissionCode.AUDIT_READ,
  },
];
